import React, { useState } from "react";
import useFetch from "../../../hooks/useFetch";
import SelectInput from "../../common/SelectInput";
import TextAreaFieldGroup from "../../common/TextAreaFieldGroup";
import TextInputModal from "../../common/TextInputModal";
import { CheckBoxInput } from "../../common/Buttons";

function SmsEditModal(props) {
  const { value } = useFetch("/api/v1/countries");
  const countries =
    value?.data?.map((e) => ({ value: e.id, label: e.en_name })) || [];
  const action = props.action;
  const [state, setState] = useState({
    id: props.data?.id || "",
    body: props.data?.body || "",
    message: props.data?.message || "",
    identifier: props.data?.identifier || "",
    country_id: props.data?.country_id || undefined,
    technorama: props.data?.technorama || false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = () => {
    let errorValid = {};
    if (!state.message) errorValid.message = ["Fill in the field"];
    if (!state.body) errorValid.body = ["Fill in the field"];
    if (!state.country_id) errorValid.country_id = "Fill in the field";
    if (Object.entries(errorValid).length > 0) {
      return setErrors(errorValid);
    }
    const variables = {
      sms_template: {
        body: state.body,
        message: state.message,
        identifier: state.identifier,
        country_id: state.country_id,
        technorama: state.technorama,
      },
    };
    if (action == "new") {
      props.postSmsItem(variables).then((res) => {
        if (res.success) props.closeModal();
      });
    } else if (action === "edit") {
      props.updateSmsItem(state.id, variables).then((res) => {
        if (res.success) props.closeModal();
      });
    }
  };

  return (
    <div className="d-flex flex-column justify-content-between h-100">
      <div>
        <SelectInput
          label="Country"
          required={true}
          options={countries}
          value={state.country_id}
          onChange={(value) =>
            handleChange({ target: { name: "country_id", value } })
          }
          error={errors.country_id}
        />
        <TextInputModal
          required={true}
          text="Message"
          name="message"
          value={state.message}
          error={errors.message && errors.message.map((item) => `${item} `)}
          onChange={(e) => handleChange(e)}
        />
        <TextAreaFieldGroup
          validate={true}
          type="text"
          placeholder="Body"
          name="body"
          value={state.body}
          error={errors.body}
          onChange={(e) => handleChange(e)}
        />

        <TextInputModal
          text="Identifier"
          name="identifier"
          value={state.identifier}
          error={
            errors.identifier && errors.identifier.map((item) => `${item} `)
          }
          onChange={(e) => handleChange(e)}
        />
        <CheckBoxInput
          className="mt-2"
          text="Technorama"
          checked={state.technorama}
          onChange={(e) =>
            handleChange({
              target: { name: "technorama", value: e.target.checked },
            })
          }
        />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-primary btn-block"
          aria-label="Close"
          onClick={() => onSubmit()}
        >
          Save
        </button>
      </div>
    </div>
  );
}

export default SmsEditModal;
